import React from 'react';

import { useField } from 'react-final-form';

import { AsyncSelectView } from './AsyncSelect.view';

export const AsyncSelect = (props: any) => {
  const { input, meta } = useField(props.name, props);

  return (
    <AsyncSelectView
      input={input}
      meta={meta}
      options={props.options}
      label={props.label}
      isDisabled={props.isDisabled}
      isRequired={props.isRequired}
      isClearable={props.isClearable}
      placeholder={props.placeholder}
      size={props.size}
      onInputChange={props.onInputChange}
      defaultOptions={props.defaultOptions}
      loadOptions={props.loadOptions}
    />
  );
};
